import type { TestFunction } from 'yup/lib/util/createValidation'

import type { TQuestionAnswer } from '$/types/components/questions'

const questionAnswerValueTest: TestFunction<
  // TODO: Extended because of yup shape validation cannot have optional fields
  (TQuestionAnswer & { name: string; subjectId: string })[] | undefined
> = (data) => {
  if (typeof data?.length === 'number') {
    return data?.length > 0
  }
  // Passed non-array value, probably by defaultValue
  return true
}

export default questionAnswerValueTest
